import React, { useEffect, useMemo, useState } from 'react';
import { firmarAusencia, incrementarContadorCeldaHoraria, fetchParametro } from './Guardias-Api';

async function procesarAusenciasYContador(ausencias, celdaHorariaId, onClose) {
    for (const ausencia of ausencias) {
        if (!ausencia.firmada) { // Solo procesar ausencias no firmadas
            try {
                const responseAusencia = await firmarAusencia(ausencia.id);
                console.log('Ausencia firmada:', responseAusencia);
                // alert('Ausencia firmada correctamente');
            } catch (error) {
                console.error('Error al firmar ausencia:', error);
                alert('Error al firmar ausencia');
                // Considera si quieres detener la ejecución en caso de error
                // o continuar con las siguientes ausencias.
            }
        }
    }

    try {
        const responseContador = await incrementarContadorCeldaHoraria(celdaHorariaId);
        console.log('Contador de celda horaria incrementado:', responseContador);
        // alert('Contador de celda horaria incrementado correctamente');
        onClose();
    } catch (error) {
        console.error('Error al incrementar contador de celda horaria:', error);
        alert('Error al incrementar contador de celda horaria');
    }
}

const AbsenceDetailModal = ({ isOpen, onClose, fecha, franja, ausencias = [], celdaHorariaId, profesoresGuardia = [], loading = false, error = null, loggedProfesorId }) => {
    const [mostrarInfoOtros, setMostrarInfoOtros] = useState(false);
    const guardiaBadgeColors = [
        "#0d6efd",
        "#6610f2",
        "#198754",
        "#dc3545",
        "#fd7e14",
        "#20c997",
        "#6f42c1",
        "#0dcaf0",
        "#6c757d",
        "#d63384",
    ];
    const getGuardiaBadgeColor = (nombre) => {
        if (!nombre) return guardiaBadgeColors[0];
        let hash = 0;
        for (let i = 0; i < nombre.length; i += 1) {
            hash = (hash * 31 + nombre.charCodeAt(i)) % guardiaBadgeColors.length;
        }
        return guardiaBadgeColors[hash];
    };

    // Función para verificar si la hora actual está dentro del rango de la franja
    const esHoraEnRango = useMemo(() => {
        if (!isOpen || !franja?.horaInicio || !franja?.horaFin) {
            return false;
        }

        const ahora = new Date();
        const fechaInicioFranja = new Date(`${fecha}T${franja.horaInicio}`);
        const fechaFinFranja = new Date(`${fecha}T${franja.horaFin}`);

        return ahora >= fechaInicioFranja && ahora <= fechaFinFranja;
    }, [isOpen, fecha, franja?.horaInicio, franja?.horaFin]);

    // Función para verificar si hay alguna ausencia sin firmar
    const guardiasProfesor = useMemo(() => {
        if (!loggedProfesorId) return [];
        return ausencias.filter(ausencia => ausencia?.profesorGuardia?.id === loggedProfesorId);
    }, [ausencias, loggedProfesorId]);

    const guardiasOtros = useMemo(() => {
        if (!loggedProfesorId) return [];
        return ausencias
            .filter(ausencia => ausencia?.profesorGuardia && ausencia.profesorGuardia.id !== loggedProfesorId)
            .slice()
            .sort((a, b) => {
                const nombreA = a.profesorGuardia?.nombre || '';
                const nombreB = b.profesorGuardia?.nombre || '';
                return nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
            });
    }, [ausencias, loggedProfesorId]);

    const hayAusenciaSinFirmar = useMemo(() => {
        return isOpen && guardiasProfesor.some(ausencia => !ausencia.firmada);
    }, [isOpen, guardiasProfesor]);

    // Determinar si el botón debe estar habilitado
    const botonFirmarHabilitado = useMemo(() => {
        return isOpen && esHoraEnRango && hayAusenciaSinFirmar && !!celdaHorariaId && !loading;
    }, [isOpen, esHoraEnRango, hayAusenciaSinFirmar, celdaHorariaId, loading]);

    useEffect(() => {
        const PARAM_NAME = "MOSTRAR_INFO_OTROS_GUARDIAS";
        fetchParametro(PARAM_NAME, true)
            .then((data) => {
                if (data && typeof data.valor === "boolean") {
                    setMostrarInfoOtros(data.valor);
                } else {
                    setMostrarInfoOtros(false);
                }
            })
            .catch(() => setMostrarInfoOtros(false));
    }, []);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal fade show" id="modalDetalleGuardia" tabIndex="-1" aria-modal="true" style={{ display: 'block', marginTop: '6rem' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-primary text-white">
                        <h5 className="modal-title">Gestión de Guardias</h5>
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                        <h6 className="mb-3">
                            Ausencias para el {fecha} en la franja {franja?.horaInicio} - {franja?.horaFin}
                            {franja?.descripcion ? ` (${franja.descripcion})` : ''}
                        </h6>

                        {error && <div className="alert alert-danger">{error}</div>}
                        {loading ? (
                            <div className="text-center py-3">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                {guardiasProfesor.length === 0 && guardiasOtros.length === 0 ? (
                                    <div className="alert alert-info">No hay ausencias registradas para esta franja.</div>
                                ) : (
                                    <div className="row">
                                        <div className={mostrarInfoOtros ? "col-md-6" : "col-12"}>
                                            <h6 className="mb-2">Tus guardias</h6>
                                            {guardiasProfesor.length === 0 ? (
                                                <div className="alert alert-light">No tienes guardias asignadas en esta franja.</div>
                                            ) : (
                                                guardiasProfesor.map(ausencia => (
                                                    <div key={ausencia.id} className={`card mb-2 ${ausencia.profesorGuardia ? 'border-success' : 'border-warning'}`}>
                                                        <div className="card-body p-2">
                                                            <div className="fw-bold">{ausencia.profesor.nombre}</div>
                                                            <div className="small text-muted"><strong>Aula origen:</strong> {ausencia.celdaHoraria?.aula?.codigo || 'Sin aula'}</div>
                                                            <div className="small text-muted"><strong>Aula destino:</strong> {ausencia.aulaDestino?.codigo || 'Sin aula destino'} {ausencia.aulaDestino?.descripcion ? `(${ausencia.aulaDestino.descripcion})` : ''}</div>
                                                            <div className="small text-muted"><strong>Grupos:</strong> {ausencia.celdaHoraria?.grupos}</div>
                                                            <div className="small text-muted"><strong>Observaciones:</strong> {ausencia.observaciones || 'Sin observaciones'}</div>
                                                            <div className="small text-muted"><strong>Observaciones Jefatura:</strong> {ausencia.observacionesAgrupacion || 'Sin observaciones'}</div>
                                                            {ausencia.profesorGuardia && (
                                                                <div className="mt-1">
                                                                    <span className="badge bg-success">Guardia: {ausencia.profesorGuardia.nombre}</span>
                                                                </div>
                                                            )}
                                                            <div className="mt-1">
                                                                {ausencia.firmada ? (
                                                                    <span className="badge bg-success">Firmada</span>
                                                                ) : (
                                                                    <span className="badge bg-danger">No firmada</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        {mostrarInfoOtros && (
                                            <div className="col-md-6">
                                                <h6 className="mb-2">Guardias de otros profesores</h6>
                                                {guardiasOtros.length === 0 ? (
                                                    <div className="alert alert-light">No hay guardias de otros profesores en esta franja.</div>
                                                ) : (
                                                    guardiasOtros.map(ausencia => (
                                                        <div key={ausencia.id} className="card mb-2 border-light">
                                                            <div className="card-body p-2">
                                                                <div className="fw-bold">{ausencia.profesor.nombre}</div>
                                                                <div className="small text-muted"><strong>Aula origen:</strong> {ausencia.celdaHoraria?.aula?.codigo || 'Sin aula'}</div>
                                                                <div className="small text-muted"><strong>Aula destino:</strong> {ausencia.aulaDestino?.codigo || 'Sin aula destino'} {ausencia.aulaDestino?.descripcion ? `(${ausencia.aulaDestino.descripcion})` : ''}</div>
                                                                <div className="small text-muted"><strong>Grupos:</strong> {ausencia.celdaHoraria?.grupos}</div>
                                                                {ausencia.profesorGuardia && (
                                                                    <div className="mt-1">
                                                                        <span
                                                                            className="badge"
                                                                            style={{
                                                                                backgroundColor: getGuardiaBadgeColor(ausencia.profesorGuardia.nombre),
                                                                            }}
                                                                        >
                                                                            Guardia: {ausencia.profesorGuardia.nombre}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {mostrarInfoOtros && (
                                    <div className="mt-4">
                                        <h6 className="mb-2">Profesores de guardia en esta franja</h6>
                                        {profesoresGuardia.length === 0 ? (
                                            <div className="alert alert-light">No hay profesores de guardia configurados para esta franja.</div>
                                        ) : (
                                            <ul className="list-group list-group-flush">
                                                {profesoresGuardia.map(profesor => (
                                                    <li key={profesor.id} className="list-group-item d-flex justify-content-between align-items-center py-2">
                                                        <span>{profesor.nombre}</span>
                                                        <span className="d-flex align-items-center gap-2">
                                                            {profesor.ausente && <span className="badge bg-danger">Ausente</span>}
                                                            <span className="badge bg-primary">({profesor.contadorGuardias})</span>
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => procesarAusenciasYContador(guardiasProfesor, celdaHorariaId, onClose)}
                            disabled={!botonFirmarHabilitado}
                        >
                            Firmar Guardias
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AbsenceDetailModal;
